import { ChannelState } from '../enums/channel-state.enum';

export const channelStateToEnum = (state: string | number): ChannelState => {
  const stateNum = isNaN(+state) ? 0 : +state;

  switch (stateNum) {
  case 1:
    return ChannelState.RUNNING;
  case 2:
    return ChannelState.PAUSED;
  case 3:
    return ChannelState.STOPPED;
  case 4:
    return ChannelState.FAULTED;
  default:
    return ChannelState.STOPPED;
  }
};
